const e = {
  suffixTextColor: "var(--n-icon-color)"
};
export {
  e as inlineThemeOverrides
};
